import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { takeUntil } from "rxjs/operators";
import { ItemCategoryFormComponent } from "../item-category-form/item-category-form.component";

@Component({
  selector: "ngx-item-category-list",
  templateUrl: "./item-category-list.component.html",
  styleUrls: ["./item-category-list.component.scss"],
})
export class ItemCategoryListComponent extends BaseListComponent {
  IgnoreDelete: boolean = false;
  deleteMessage: string = "";
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;
  
  constructor() {
    super();
    this.inputEditorform = ItemCategoryFormComponent;
    this.FillData();
  }

  ngOnInit() {
    this.apiName = "ItemCategory";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Catalog.ItemCategory.ItemCategory");
  }

  async FillData() {
    const info = this.accountService.authService.currentInformation();
    if (info.RestaurantCallCenter) {
      if (!this.accountService.authService.currentBranch.AccessToAllBranches) {
        this.isAdd = false;
        this.isEdit = false;
        this.isDelete = false;
      }
    }
    if (info.BranchingLightEnabled || info.BranchingAdvancedEnabled) {
      const hasBranchCommunication = JSON.parse(localStorage.getItem("HasBranchCommunication"));
      if (hasBranchCommunication == null) {
        this.httpCommonService
          .getList(`Branch/HasBranchCommunication/${this.accountService.authService.currentBranchId}`)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(async (hbc: boolean) => {
            if (hbc === true) {
              this.IgnoreDelete = true;
              this.deleteMessage = this.translate("ClientApp.FrontOffice.Catalog.ItemCategory.HasBranchCommunication");
            }
          });
      } else if (hasBranchCommunication) {
        this.IgnoreDelete = true;
        this.deleteMessage = this.translate("ClientApp.FrontOffice.Catalog.ItemCategory.HasCallCenterCommunication");
      }
    }
  }
}
